import axios from "axios";

// Same-origin lead submission with a per-attempt idempotency key.
// A retry after a failure reuses the same client_submission_id so the server
// never stores the same inquiry twice or queues a second email job.

export function newSubmissionId() {
  if (typeof crypto !== "undefined" && crypto.randomUUID) return `sub_${crypto.randomUUID()}`;
  return `sub_${Date.now().toString(36)}_${Math.random().toString(36).slice(2, 10)}`;
}

export function normalizeSubmitError(err) {
  if (!err?.response) {
    return {
      kind: "network",
      message: "We could not reach the server. Check your connection and try again. Your answers are still on this page.",
      fields: {},
    };
  }
  const { status, data } = err.response;
  const detail = typeof data?.detail === "string" ? data.detail : "";
  if (status === 422 || data?.kind === "validation") {
    return {
      kind: "validation",
      message: detail || "Please check the highlighted fields and try again.",
      fields: data?.errors && typeof data.errors === "object" ? data.errors : {},
    };
  }
  return {
    kind: "server",
    status,
    message: detail || `Something went wrong on our end (HTTP ${status}). Your answers are still on this page; please try again.`,
    fields: {},
  };
}

export async function submitLead(path, payload, submissionId) {
  const res = await axios.post(path, { ...payload, client_submission_id: submissionId }, { withCredentials: true, timeout: 30000 });
  if (!(res.status >= 200 && res.status < 300) || !res.data?.ok) {
    const e = new Error("Unexpected response");
    e.response = { status: res.status, data: res.data };
    throw e;
  }
  return res.data;
}
